import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import InforCard from '../../components/sections/Profile/InfoCard';
import { useTranslation } from 'react-i18next';
import BaseUrl from "../../config/constant";
import ModalRegistrationHistory from '../../components/sections/Profile/ModalRegistrationHistory';

export default function Index() {
  const navigate = useNavigate();
  const jwtToken = localStorage.getItem('jwt-token');
  const [profile, setProfile] = useState(null);
  const [registerEventHistory, setRegisterEventHistory] = useState([]);
  const [isActiveRegisterEvent, setIsActiveRegisterEvent] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isModalHistory, setIsModalHistory] = useState(false);
  const { t, i18n } = useTranslation();

  const regionNames = new Intl.DisplayNames([i18n.resolvedLanguage], {
    type: 'region',
  });

  const getProfile = async () => {
    const jwt = JSON.parse(jwtToken);

    axios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${jwt?.access_token}`;

    await axios
      .get(`${BaseUrl}/profile`)
      .then((response) => {
        setProfile(response.data.data);
      })
      .catch((error) => {
        console.error(error);
        localStorage.removeItem('jwt-token');
      });
  };

  const getRegisHistory = async () => {
    const jwt = JSON.parse(jwtToken);

    axios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${jwt?.access_token}`;

    await axios
      .get(`${BaseUrl}/event-history/564`)
      .then((response) => {
        const data = response.data.data;
        const activeRegister = data.map((event) => event.uuehTrnsStatus === 1 || event.uuehTrnsStatus === 0)

        setRegisterEventHistory(response.data.data);
        setIsActiveRegisterEvent(activeRegister[0]);
      })
      .catch((error) => {
        console.error(error);
        localStorage.removeItem('jwt-token');
      });
  }

  const handleLogout = async () => {
    setLoading(true);
    const jwt = JSON.parse(jwtToken);

    await axios
      .post(`${BaseUrl}/logout`, {
        data: {
          refresh_token: jwt.refresh_token,
        },
      })
      .then((response) => {
        localStorage.removeItem('jwt-token');
        setLoading(false);
        navigate('/login');
      })
      .catch((error) => {
        console.info('error', error);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!jwtToken) {
      navigate('/login');
    }

    getProfile();
    getRegisHistory();
  }, []);

  return (
    <div className="md:px-0 px-4">
      <div className="relative h-[240px] md:h-[300px] bg-brand-blue flex justify-center items-center mt-[86px] md:mt-[109px] 2xl:mt-[136px]">
        <div className="relative">
          <h1 className="md:text-4xl text-2xl font-boldonse font-bold italic uppercase text-white">
            {t("profile.title")}
          </h1>
        </div>
      </div>
      <div className="relative top-50 bg-white 2xl:px-0 md:px-14 px-0">
        <div className="bg-white min-h-screen h-full container mx-auto w-full font-ttFirsNeue">
          <div className="top-10 md:top-40 bg-white 2xl:px-0 md:px-14 px-0 py-5 pb-20 lg:pb-40">
            <div className="bg-white container mx-auto px-4 w-full font-poppins text-[#164481]">
              <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-10">
                <section className="mb-10 md:mb-14">
                  <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
                    <div className="relative flex items-center justify-center bg-gradient-to-br bg-black text-white font-bold rounded-full transition-transform duration-300 hover:scale-105 w-24 h-24 md:w-32 md:h-32 shadow-2xl">
                      <span className="text-2xl md:text-3xl font-evil tracking-wider">
                        {profile?.uusrName?.match(/\b\w/g)?.join('') ?? ''}
                      </span>
                    </div>

                    <div className="text-center md:text-left flex-1">
                      <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-black font-poppins mb-2">
                        {profile?.uusrName}
                      </h1>
                      <p className="text-gray-500 text-sm md:text-base mb-4">
                        {profile?.uusrEmail}
                      </p>
                      <div className="flex flex-wrap justify-center md:justify-start gap-3">
                        <button
                          disabled={isActiveRegisterEvent}
                          onClick={() => {
                            navigate('/registration');
                          }}
                          className={`${isActiveRegisterEvent && 'bg-[#ffc68e] hover:cursor-not-allowed translate-y-0 hover:translate-y-0 hover:shadow-none hover:bg-[#ffc68e]'} px-6 py-2.5 bg-[#F79838] text-white font-semibold rounded-lg transition-all duration-300 hover:bg-[#df8830] hover:shadow-lg transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[#eccd38] focus:ring-offset-2`}
                        >
                          {t("profile.registerEvent")}
                        </button>
                        <button onClick={() => {
                          setIsModalHistory(true);
                        }} className="px-6 py-2.5 bg-[#F79838] text-white font-semibold rounded-lg transition-all duration-300 hover:bg-[#df8830] hover:shadow-lg transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[#eccd38] focus:ring-offset-2">
                          {t("profile.registerHistory")}
                        </button>
                        <button
                          onClick={handleLogout}
                          className="px-6 py-2.5 bg-red-600 text-white font-semibold rounded-lg transition-all duration-300 hover:bg-red-700 hover:shadow-lg transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[#eccd38] focus:ring-offset-2"
                        >
                          {loading ? (
                            <div className='flex items-center justify-center'>
                              <div className="h-6 w-6 animate-spin rounded-full border-b-2 border-current" />
                            </div>
                          ) : 'Logout'} 
                        </button>
                      </div>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-black font-poppins mb-6 flex items-center gap-2">
                    <span className="w-1.5 h-8 bg-[#F79838] rounded-full"></span>
                    {t("profile.personal")}
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                    <InforCard
                      label={t("profile.fullname")}
                      profile={profile?.uusrName}
                      icon={
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                          ></path>
                        </svg>
                      }
                    />

                    <InforCard
                      label={t("profile.email")}
                      profile={profile?.uusrEmail}
                      icon={
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                          ></path>
                        </svg>
                      }
                    />

                    <InforCard
                      label={t("profile.phone")}
                      profile={profile?.uusrPhoneNumber
                        .replace(/^62(\d{3})(\d{4})(\d{4})$/, "+62 $1-$2-$3")}
                      icon={
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                          ></path>
                        </svg>
                      }
                    />

                    <InforCard
                      label={t("profile.gender")}
                      profile={
                        profile?.uusrGender === 1 ? 'Laki-laki' : 'Perempuan'
                      }
                      icon={
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                          ></path>
                        </svg>
                      }
                    />

                    <InforCard
                      label={t("profile.blood")}
                      profile={profile?.uusrBloodType}
                      icon={
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                          ></path>
                        </svg>
                      }
                    />

                    <InforCard
                      label={t("profile.nationality")}
                      profile={
                        profile && regionNames.of(profile?.uusrNationality)
                      }
                      icon={
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M3 21v-8a2 2 0 012-2h14a2 2 0 012 2v8M3 21h18M5 11V7a2 2 0 012-2h14a2 2 0 012 2v4M5 11h14"
                          ></path>
                        </svg>
                      }
                    />

                    <InforCard
                      label={t("profile.identity")}
                      profile={profile?.uusrIdentityType === 1 ? 'KTP' : '-'}
                      icon={
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
                          ></path>
                        </svg>
                      }
                    />

                    <InforCard
                      label={t("profile.identityNo")}
                      profile={profile?.uusrIdentityNumber}
                      icon={
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
                          ></path>
                        </svg>
                      }
                    />

                    <InforCard
                      label={t("profile.dob")}
                      profile={profile?.uusrDateOfBirth}
                      icon={
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          ></path>
                        </svg>
                      }
                    />

                    <InforCard
                      label={t("profile.occupation")}
                      profile={profile?.uusrOccupation}
                      icon={
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                          ></path>
                        </svg>
                      }
                    />

                    <InforCard
                      label={t("profile.community")}
                      profile={profile?.uusrCommunity}
                      icon={
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                          ></path>
                        </svg>
                      }
                    />
                  </div>
                </section>

                {isModalHistory && <ModalRegistrationHistory handleClose={setIsModalHistory} registerEventHistory={registerEventHistory} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
